export default __webpack_public_path__ + "static/anders-0ec33c7e9e0b74ac7567aa47c431fb2f.png";